import React, { useEffect, useState } from 'react';
import { history, connect, useIntl, useRouteMatch } from 'umi';
import IntelligenceSources from './component/IntelligenceSources';
import NewsCrawlers from './component/NewsCrawlers';
import OpinionsSources from './component/OpinionsSources';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import { GuideSourcesMetricsDelay as GuideSourcesMetrics } from '@intelligence/components/UserGuide/SourcesMetrics';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
const { Body, Sider, Content } = Layout;


function Sources(props: any) {
  // const [activeId, setActiveId] = useState('IntelligenceSources');
  const [bodyLoading, setBodyLoading] = useState(false);

  const { params }: any = useRouteMatch() || {};
  const tabId = params?.tab || 'IntelligenceSources'

  // console.log("tab", tabId)

  const { formatMessage } = useIntl();

  useEffect(() => {
    if (!['IntelligenceSources', 'OpinionsSources', 'NewsCrawlers']?.includes(tabId)) {
      history.push(`/intelligence/sourcesMetrics/sources/IntelligenceSources`);
    }
  }, [tabId])
  // TODO:多余筛选器可以删除，直接复用其他页面的
  const tabs = [
    {
      id: 'IntelligenceSources',
      label: formatMessage({ id: 'dbi-sm-intelligence-sources' }),
      component: <IntelligenceSources />,
    },
    {
      id: 'OpinionsSources',
      label: formatMessage({ id: 'dbi-sm-opinions-sources' }),
      component: <OpinionsSources />,
    },
    {
      id: 'NewsCrawlers',
      label: formatMessage({ id: 'dbi-sm-news-crawlers' }),
      component: <NewsCrawlers />,
    },
  ];
  return (
    <Content>
      <Content.Header
        title={formatMessage({ id: 'dbi-sm-sources' })}
        className="contentHead-normal"
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="Sources&MetricsSources"
            tabs={tabs}
            animated={false}
            activeId={tabId}
            onActive={(tab) => {
              const url = `/intelligence/sourcesMetrics/sources/${tab.id}`
              history.push(url);
            }}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        <MarqueeBanner />
        {bodyLoading ? null : (
          tabs.map((e) => <div key={e.id} id="title">{e.id == tabId ? e.component : ''}</div>)
        )
        }
      </Content.Body>
      <GuideSourcesMetrics />
    </Content>
  );
};

export default connect((state: any) => ({
}))(Sources);
